/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReplacer } from '../../factoriesAny.js';
export var replacerDependencies = {
  createReplacer
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesReplacer.generated.js
// module id = null
// module chunks = 